
import rect   from 'dom/rect.js'
import events from 'dom/events.js'
import select from 'dom/select.js'

const color = window.config.animatedScrollColor || [245, 245, 245];
const fullValue = 255;

events('DOMContentLoaded scroll', window)
.each(function() {
    const vh = window.innerHeight;

    select('[data-highlightable]', document)
    .forEach(function(node) {
        const box = rect(node);
        if (!box) { return; }

        // If node is not in view, ignore
        if (box.bottom < 0 || box.top > vh) {
            node.classList.remove('hl-on');
            return;
        }

        const opacity = box.top < vh/2 ?
            box.bottom > vh/2 ?
                1 :
                box.bottom / (vh / 2) :
            (vh - box.top) / (vh / 2) ;

        if (opacity > 0.9) {
            node.classList.add('hl-on');
        } else {
            node.classList.remove('hl-on');
        }

        const shade = color.map((value) => Math.round(value + (fullValue - value) * Math.pow(opacity, 3)));

        node.style.backgroundColor = 'rgb(' + shade.join(',') + ')';

        /* Recent update - use variable to propogate bg color to things like the
           fade effect at the bottom of read-more-toggle */
        node.style.setProperty('--background-color', 'rgb(' + shade.join(',') + ')');
    });
});
